const LOAD_VISTAR_ACCOUNT_NETWORKS = "vistar-account::networks::load-all";
const LOAD_VISTAR_ACCOUNTS_FAILURE = "vistar-accounts::load-all::failure";
const LOAD_VISTAR_ACCOUNTS_SUCCESS = "vistar-accounts::load-all::success";
const LOAD_VISTAR_VENUES = "vistar-account::venues::load-all";

export {
  LOAD_VISTAR_ACCOUNT_NETWORKS,
  LOAD_VISTAR_ACCOUNTS_FAILURE,
  LOAD_VISTAR_ACCOUNTS_SUCCESS,
  LOAD_VISTAR_VENUES,
};
